/** This release set uses the rich editor even for unformatted legacy strings. */
export function supportsReleaseSocialMediaFormatting(channel: string, contentType: string, set: string | null | undefined) {
  return channel === "releases" && contentType === "release" && set === "social-media";
}
